<template>
  <div class="master-tabs">
    <ul class="nav nav-tabs mb-3">
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{ active: currentTab === 'list' }"
          href="#"
          @click.prevent="$emit('tab-change', 'list')"
        >
          <i class="fas fa-list me-2"></i>一覧・検索
        </a>
      </li>
      <li
        class="nav-item"
        v-if="
          chk_relation_type_editable('/master/list') &&
          manage_account_level_disp
        "
      >
        <a
          class="nav-link"
          :class="{ active: currentTab === 'create' }"
          href="#"
          @click.prevent="$emit('tab-change', 'create')"
        >
          <i class="fas fa-plus me-2"></i>新規作成
        </a>
      </li>
      <li class="nav-item" v-if="chk_relation_type_editable('/master/list')">
        <a
          class="nav-link"
          :class="{ active: currentTab === 'import' }"
          href="#"
          @click.prevent="$emit('tab-change', 'import')"
        >
          <i class="fas fa-upload me-2"></i>CSVインポート
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MasterTabs',
  props: {
    currentTab: {
      type: String,
      default: 'list'
    }
  },
  emits: ['tab-change']
}
</script>

<style scoped>
.nav-link {
  color: #495057;
  border-color: #dee2e6;
}

.nav-link:hover {
  color: #007bff;
  border-color: #dee2e6 #dee2e6 #007bff;
}

.nav-link.active {
  color: #007bff;
  background-color: #fff;
  border-color: #007bff #007bff #fff;
}

.fas {
  font-size: 0.9em;
}
</style>
